import { render, staticRenderFns } from "./RedBorderPreview.vue?vue&type=template&id=39b7d188&lang=html&"
import script from "./RedBorderPreview.vue?vue&type=script&lang=js&"
export * from "./RedBorderPreview.vue?vue&type=script&lang=js&"
import style0 from "./RedBorderPreview.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports